module.exports = __webpack_public_path__ + "d1b435aadaf7ee9e164a1ca385e6b8f1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/heros/scalable-graphic.png
// module id = 776
// module chunks = 0